import { render, staticRenderFns } from "./CarriageWrapper.vue?vue&type=template&id=70604d06&"
import script from "./CarriageWrapper.vue?vue&type=script&lang=js&"
export * from "./CarriageWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports